import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=d524983a&scoped=true"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=d524983a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d524983a",
  null
  
)

export default component.exports